<template>
  <div
    class="animate-fade-in relative inline-flex items-center rounded-full px-3 py-1
    text-sm text-gray-500 dark:text-gray-300 ring-1 ring-gray-900/10
    dark:ring-white/10 hover:ring-gray-900/20 dark:hover:ring-white/20"
  >
    <slot />

    <a
      v-if="href"
      :href="href"
      class="ml-2 font-semibold whitespace-nowrap text-primary"
    >
      <span
        class="absolute"
        aria-hidden="true"
      />
      <span class="hover:underline">{{ linkText }}</span> <span
        class="ml-2"
        aria-hidden="true"
      >&rarr;</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';

defineProps<{
  href?: string;
  linkText?: string;
}>();
</script>
